"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeState = void 0;
const reduceKeys_1 = require("./reduceKeys");
function mergeState(storeState, sinkState, dispatches) {
    const merged = Object.assign({}, dispatches);
    const defineProperties = reduceKeys_1.reduceKeys(Object.keys(sinkState), (key) => {
        let state = storeState && storeState[key];
        if (state === undefined) {
            state = sinkState[key];
        }
        return {
            get: () => state,
            set: (value) => dispatches[key](value),
        };
    });
    Object.defineProperties(merged, defineProperties);
    return merged;
}
exports.mergeState = mergeState;
